/* Стеклянная карточка. Световое пятно следует за курсором через CSS-переменные,
   перерисовки React нет: значения пишутся прямо в style элемента. */
export const Surface = ({ as: Tag = "div", className = "", children, ...rest }) => {
  const track = (e) => {
    const r = e.currentTarget.getBoundingClientRect();
    e.currentTarget.style.setProperty("--x", `${e.clientX - r.left}px`);
    e.currentTarget.style.setProperty("--y", `${e.clientY - r.top}px`);
  };
  return (
    <Tag onPointerMove={track} className={`surface ${className}`} {...rest}>
      {children}
    </Tag>
  );
};
